// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enHomepage from './locales/en/homepage.json';
import hiHomepage from './locales/hi/homepage.json';
import mrHomepage from './locales/mr/homepage.json';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: true,
    interpolation: { escapeValue: false },
    resources: {
      en: {
        homepage: enHomepage
      },
      hi: {
        homepage: hiHomepage
      },
      mr: {
        homepage: mrHomepage
      }
    },
    ns: ['homepage'],
    defaultNS: 'homepage',
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage', 'cookie'],
    },
  });

export default i18n;